import { useContext } from 'react';
import { VarianceDetailsContext } from 'src/sections/variance_details/VarianceDetailsContext';
const useVarianceDetails = () => {
  const context = useContext(VarianceDetailsContext);
  if (!context)
    throw new Error('Variance Details context must be used inside VarianceDetailsContextProvider');
  return context;
};

export default useVarianceDetails;
